"use client"

// * ? ATTENTION: React 19 - Review for compatibility

import * as React from "react"
import { ChevronRight } from "lucide-react"

import { cn } from "@/lib/utils"
import {
    SidebarGroup,
    SidebarGroupContent,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    SidebarMenuSub,
    SidebarMenuSubItem,
    SidebarMenuSubButton,
    SidebarMenuAction,
} from "@/components/ui/sidebar"
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible"

// Recursive type for navigation items with nested children
type NavItem = {
    title: string
    url: string
    icon?: React.ElementType
    children?: NavItem[]
}

// Recursive component for rendering nested navigation items
function NavMenuItem({ item, level = 0 }: { item: NavItem; level?: number }) {
    const hasChildren = item.children && item.children.length > 0

    if (hasChildren) {
        return (
            <Collapsible defaultOpen className="group/submenu">
                <CollapsibleTrigger asChild>
                    <SidebarMenuSubButton className="cursor-pointer w-full justify-between">
                        <span className="flex items-center gap-2">
                            {item.icon && <item.icon className="size-4" />}
                            <span>{item.title}</span>
                        </span>
                        <ChevronRight className="size-4 transition-transform group-data-[state=open]/submenu:rotate-90" />
                    </SidebarMenuSubButton>
                </CollapsibleTrigger>
                <CollapsibleContent>
                    <SidebarMenuSub className={cn(level > 0 && "ml-2 border-l border-sidebar-border")}>
                        {item.children!.map((child) => (
                            <SidebarMenuSubItem key={child.title}>
                                <NavMenuItem item={child} level={level + 1} />
                            </SidebarMenuSubItem>
                        ))}
                    </SidebarMenuSub>
                </CollapsibleContent>
            </Collapsible>
        )
    }

    return (
        <SidebarMenuSubButton asChild>
            <a href={item.url}>
                {item.icon && <item.icon className="size-4" />}
                <span>{item.title}</span>
            </a>
        </SidebarMenuSubButton>
    )
}

export function NavMain({ items }: { items: NavItem[] }) {
    return (
        <SidebarGroup>
            <SidebarGroupContent className="flex flex-col gap-2">
                <SidebarMenu>
                    {items.map((item) => (
                        <SidebarMenuItem key={item.title}>
                            {item.children && item.children.length > 0 ? (
                                <Collapsible defaultOpen className="group/collapsible">
                                    <CollapsibleTrigger asChild>
                                        <SidebarMenuButton tooltip={item.title}>
                                            {item.icon && <item.icon />}
                                            <span>{item.title}</span>
                                            <SidebarMenuAction asChild>
                                                <span aria-hidden="true">
                                                    <ChevronRight className="ml-auto transition-transform group-data-[state=open]/collapsible:rotate-90" />
                                                </span>
                                            </SidebarMenuAction>
                                        </SidebarMenuButton>
                                    </CollapsibleTrigger>
                                    <CollapsibleContent>
                                        <SidebarMenuSub>
                                            {item.children.map((child) => (
                                                <SidebarMenuSubItem key={child.title}>
                                                    <NavMenuItem item={child} level={1} />
                                                </SidebarMenuSubItem>
                                            ))}
                                        </SidebarMenuSub>
                                    </CollapsibleContent>
                                </Collapsible>
                            ) : (
                                <SidebarMenuButton asChild tooltip={item.title}>
                                    <a href={item.url}>
                                        {item.icon && <item.icon />}
                                        <span>{item.title}</span>
                                    </a>
                                </SidebarMenuButton>
                            )}
                        </SidebarMenuItem>
                    ))}
                </SidebarMenu>
            </SidebarGroupContent>
        </SidebarGroup>
    )
}


// <SidebarMenu>
//   <SidebarMenuItem className="flex items-center gap-2">
//         <SidebarMenuButton
//             tooltip="Quick Create"
//             className="bg-primary text-primary-foreground hover:bg-primary/90 hover:text-primary-foreground active:bg-primary/90 active:text-primary-foreground min-w-8 duration-200 ease-linear"
//         >
//             <PlusCircle />
//             <span>Quick Create</span>
//         </SidebarMenuButton>
//         <Button
//             size="icon"
//             className="size-8 group-data-[collapsible=icon]:opacity-0"
//             variant="outline"
//         >
//             <Mail />
//             <span className="sr-only">Inbox</span>
//         </Button>
//     </SidebarMenuItem>
// </SidebarMenu>